// extracted by mini-css-extract-plugin
export default {"tasks":"IO-z","task":"JO-z","svg":"KO-z","text":"LO-z"};